import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row } from 'reactstrap';
import {
  changeBoxRegistrar,
  SetSelectedBoxes,
  showUpdateEpikBox,
  getEpikBoxData,
} from '../../../../../actions/EpikBoxes';
import { TOOLTIPS_TEXT } from '../../../../../lib/constants';
import AddSecurityCodeModal from '../../../../AddSecurityCodeModal';
import InfoPopup from '../../../../InfoPopup';
import Toggle from '../../../../Toggle';

const boxRegistrarLookup = {
  Unified: false,
  midRegistrar: true,
}

const BoxRegistrar = () => {
  const dispatch = useDispatch();
  const token = localStorage.getItem('jwtToken');
  const boxDetails = useSelector(state => state.AppState.boxDetails.box);

  const [boxregistrar, setBoxRegistrar] = useState(
    boxRegistrarLookup[boxDetails.boxRegistrar] || false,
  );
  const [modalLoading, setModalLoading] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);

  const onBoxRegistrar = () => {
    setModalStatus(true);
  };

  const checkSecurityCode = async () => {
    setModalLoading(true);
    const result = await dispatch(changeBoxRegistrar(token, boxDetails._id, !boxregistrar));
    if (result) {
      await dispatch(getEpikBoxData(token, boxDetails?._id));
      setBoxRegistrar(!boxregistrar);
    }
    setModalStatus(false);
    setModalLoading(false);
  };
  return (
    <Row className="align-items-center">
      <Col sm={5} id="test-enable-expansion-box" className="type-header d-flex">
        Enable Registration Offset
        <sup>
          <InfoPopup id="enable-new-box-registrar" text={TOOLTIPS_TEXT.BOX_REGISTRAR_CHANGE} />
        </sup>
      </Col>

      <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
        <Toggle
          value={boxregistrar}
          id="test-enable-expansion-box-toggle"
          onToggle={onBoxRegistrar}
          disabled={!['la'].includes(boxDetails?.datacenter)}
        />
      </Col>

      <AddSecurityCodeModal
        isOpen={modalStatus}
        loading={modalLoading}
        enhancedRouting
        onCancel={() => {
          setModalStatus(!modalStatus);
        }}
        onConfirm={checkSecurityCode}
        featureName={'enhancedRouting'}
      />
    </Row>
  );
};

export default BoxRegistrar;
